import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";

const useDeleteStaff = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await AXIOS_RESERVATION.delete(`v1/staff/${id}`, {
        headers: {
          pageName: "staff",
        },
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["staff"] });
    },
  });
};

export default useDeleteStaff;
